import { RootState } from "@/store/store";
import { dimensionSharedCostsSelector } from "@/store/dimensions/selectors/slice-data/shared-costs/dimensionSharedCostsSelector";

export const dimensionSharedCostsWithEvenSplitMethodExistsSelector = (
  state: RootState,
) => {
  const sharedCosts = dimensionSharedCostsSelector(state);

  return sharedCosts?.some((cost) => cost.distribution_type === "even");
};
